<script setup>

</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" class="size-5 sm:size-6">
        <!-- Clock face -->
        <circle cx="100" cy="100" r="90" fill="white" stroke="black" stroke-width="2"/>

        <!-- Hour marks -->
        <line x1="100" y1="20" x2="100" y2="30" stroke="black" stroke-width="2" transform="rotate(0 100 100)"/>
        <line x1="100" y1="20" x2="100" y2="30" stroke="black" stroke-width="2" transform="rotate(30 100 100)"/>
        <line x1="100" y1="20" x2="100" y2="30" stroke="black" stroke-width="2" transform="rotate(60 100 100)"/>
        <line x1="100" y1="20" x2="100" y2="30" stroke="black" stroke-width="2" transform="rotate(90 100 100)"/>
        <line x1="100" y1="20" x2="100" y2="30" stroke="black" stroke-width="2" transform="rotate(120 100 100)"/>
        <line x1="100" y1="20" x2="100" y2="30" stroke="black" stroke-width="2" transform="rotate(150 100 100)"/>
        <line x1="100" y1="20" x2="100" y2="30" stroke="black" stroke-width="2" transform="rotate(180 100 100)"/>
        <line x1="100" y1="20" x2="100" y2="30" stroke="black" stroke-width="2" transform="rotate(210 100 100)"/>
        <line x1="100" y1="20" x2="100" y2="30" stroke="black" stroke-width="2" transform="rotate(240 100 100)"/>
        <line x1="100" y1="20" x2="100" y2="30" stroke="black" stroke-width="2" transform="rotate(270 100 100)"/>
        <line x1="100" y1="20" x2="100" y2="30" stroke="black" stroke-width="2" transform="rotate(300 100 100)"/>
        <line x1="100" y1="20" x2="100" y2="30" stroke="black" stroke-width="2" transform="rotate(330 100 100)"/>

        <!-- Clock hands -->
        <line x1="100" y1="100" x2="100" y2="55" stroke="black" stroke-width="4" transform="rotate(0 100 100)"/> <!-- Hour hand -->
        <line x1="100" y1="100" x2="100" y2="40" stroke="black" stroke-width="2" transform="rotate(126 100 100)"/> <!-- Minute hand -->
        <line x1="100" y1="105" x2="100" y2="30" stroke="red" stroke-width="1" transform="rotate(278 100 100)"/> <!-- Second hand -->

        <!-- Center dot -->
        <circle cx="100" cy="100" r="3" fill="black"/>
    </svg>
</template>

<style scoped>

</style>
